<template>
    <div class="modal modal-open" id="modal-add-industry">
        <div class="modal-overflow">
            <div class="modal-window">
                <button class="btn btn-modal-close" @click="handleClose">
                    <i class="icon icon-cancel"></i>
                </button>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-xl-12 col-lg-12">
                            <div class="form-field form-field--text">
                                <label for="name">Name</label>
                                <input
                                    type="text"
                                    v-model="data.name"
                                    id="name"
                                />
                                <span class="error" v-if="errors.name">{{
                                    errors.name
                                }}</span>
                            </div>
                        </div>
                        <div class="col-xl-12 col-lg-12">
                            <div class="form-field form-field--text">
                                <label for="code">Code</label>
                                <input
                                    type="text"
                                    v-model="data.code"
                                    id="code"
                                />
                                <span class="error" v-if="errors.code">{{
                                    errors.code
                                }}</span>
                            </div>
                        </div>
                        <div class="col-xl-12 col-lg-12">
                            <div class="form-field form-field--tree">
                                <label for="location_type"
                                    >Location type
                                </label>
                                <treeselect
                                    v-model="data.location_type"
                                    :multiple="false"
                                    :options="locationTypeOptions"
                                    :clearOnSelect="true"
                                />
                                <span
                                    style="left: 0"
                                    class="error"
                                    v-if="errors.location_type"
                                    >{{ errors.location_type }}</span
                                >
                            </div>
                        </div>
                        <div class="col-xl-12 col-lg-12">
                            <div class="form-field form-field--tree">
                                <label for="parent_value">Parent value </label>
                                <treeselect
                                    v-model="data.parent_value"
                                    :multiple="false"
                                    :options="locationsOptions"
                                    :clearOnSelect="true"
                                />
                                <span
                                    style="left: 0"
                                    class="error"
                                    v-if="errors.parent_value"
                                    >{{ errors.parent_value }}</span
                                >
                            </div>
                        </div>
                        <div class="col-xl-12 col-lg-12">
                            <div class="btn-wrap flex jus-c--center">
                                <button
                                    @click="handleAdd"
                                    type="button"
                                    class="btn"
                                >
                                    Add
                                </button>
                                <button
                                    @click="handleClose"
                                    type="button"
                                    class="btn"
                                >
                                    Cancel
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";

export default {
    name: "addLocation",
    props: {
        onClose: {
            type: Function,
            required: true,
        },
        onAdd: {
            type: Function,
            required: true,
        },
        locationsOptions: {
            type: Array,
            default: [],
        },
        locationTypeOptions: {
            type: Array,
            default: [],
        },
    },
    components: {
        Treeselect,
    },
    data() {
        return {
            data: {
                name: "",
                code: "",
                location_type: null,
                parent_value: null,
            },
            errors: {
                name: null,
                code: null,
                location_type: null,
                parent_value: null,
            },
        };
    },

    methods: {
        handleClose(e) {
            this.onClose(e);
        },

        handleAdd() {
            this.validationFields();
            if (
                this.errors.name ||
                this.errors.code ||
                this.errors.location_type ||
                this.errors.parent_value
            ) {
                return;
            }

            this.onAdd({
                name: this.data.name,
                code: this.data.code,
                location_type: this.data.location_type,
                parent_id: this.data.parent_value,
            });
        },

        validationFields() {
            this.errors = {
                name: null,
                code: null,
                location_type: null,
                parent_value: null,
            };

            if (!this.data.name) {
                this.errors.name = "Required";
            }

            /*if (!this.data.code) {
                this.errors.code = "Required";
            }*/

            if (!this.data.location_type) {
                this.errors.location_type = "Required";
            }

            /*if (!this.data.parent_value) {
                this.errors.parent_value = "Required";
            }*/
        },
    },
};
</script>
